import { AuthService } from './Auth/auth.service';
import { Component, HostListener, OnInit, ViewChild, Renderer2 } from '@angular/core';
import { isNullOrUndefined } from 'util';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { BnNgIdleService } from 'bn-ng-idle';
import { ClientDataService } from './services/client-data.service';
import { EncrdecrService } from './Auth/encrdecr.service';
import { LoginService } from './services/login.service';
import { CustomLoaderService } from './services/custom-loader.service';
import { TokenExpireService } from './services/token-expire.service';
import { VariableService } from './services/variable.service';
import { pick } from 'highcharts';
import { DatePipe } from '@angular/common';
import { DomSanitizer } from '@angular/platform-browser';
import { LogoService } from './services/logo.service';

declare var $: any;
declare let gtag: Function;
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  //pipe = new DatePipe('en-US');
  // Companyname: string = 'AU';
  CompanyLogo: any;
  href: any;
  IsLoaded = false;
  Companyname: string = environment.CompayName;
  CommonBaseHref: string = environment.CommonBaseHref;
  PrimaryColor: string = '';
  SecondaryColor: string = '';
  ThirdColor: string = '';
  BodyColor: string = '';
  BodyBgColor: string = '';
  BodyFooterBgColor: string = '';
  Table_Header_Bg = '';
  Table_Head_Text = '';
  fontFamily = '';
  favIcon: HTMLLinkElement = document.querySelector('#Fevicon');
  //MainLogo: HTMLImageElement = document.querySelector('#MainLogo');
  logo: string;
  loader: string;
  loaderWidth: string;
  loaderHeight: string;
  SessionTime: number = 1800;
  IsMobile: boolean = false;
  IsLoggedIn: boolean = false;
  investorimg1: any;
  investorimg2: any;
  investorimg3: any;
  investorimg4: any;
  investorimg5: any;
  bannerimage: any;
  aboutusimg: any;
  test = 0;
  MFDInterval: any;
  MFDData: string = '';
  DOE: any;
  FIFO: any;
  IsShowHide: boolean = false;
  IsShowHideIFAHeader: boolean = false;
  Googleplaylink: any;
  UploadedQR: string;
  IsOptimoney = environment.IsOptimoney;
  IsOptiWealth = environment.IsOptimoneyWealth; //Added by Adarsh
  WhatsAppQR: any;
  WhatsAppLink: any;
  IsShowHideQR: boolean = true;

  private unlisten!: () => void;


  constructor(
    private Idle: BnNgIdleService,
    private titleService: Title,
    private ClientDataService: ClientDataService,
    private EncrdecrService: EncrdecrService,
    private LoginService: LoginService,
    private router: Router,
    public Loader: CustomLoaderService,
    private Logout: TokenExpireService,
    private appVariable: VariableService,
    private authservice: AuthService,
    public sanitizer: DomSanitizer,
    private logoService: LogoService,
    private renderer: Renderer2
  ) {
    // initiate it in your component constructor
    //sessionStorage.removeItem('6+J3RebINEPBJVbAJw');

    this.SessionTime = 1800; //350 -5min 50sec 660 1050-15min || 300sec = 5min ||1800sec = 30min

    this.Idle.startWatching(this.SessionTime).subscribe((res) => {
      if (res) {
        //;
        if (
          sessionStorage.getItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF') != null &&
          sessionStorage.getItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF') != undefined &&
          sessionStorage.getItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF') != ''
        ) {
          const isLoggtedIn = this.EncrdecrService.getDecr(
            sessionStorage.getItem('5V5uSYBoBVqAvBIBqUEBhv6ELFF')
          );
          if (isLoggtedIn == '1') {
            this.IsLoggedIn = true;
          } else {
            this.IsLoggedIn = false;
          }
        } else {
          this.IsLoggedIn = false;
        }
        if (res == true) {
          var Domain_Name = window.location.host;
          this.ClientDataService.SetWelcomeText('');
          this.titleService.setTitle(Domain_Name);
          sessionStorage.setItem('Abodhj#@jdkd/%^ysudsh&#&shdj@#$', '0');
          sessionStorage.setItem('logo', '../../assets/images/OptimumLogo.svg');
          sessionStorage.setItem(
            'Abodhj#@jdkd/%^82ncdbcnggshd!@#$',
            this.EncrdecrService.setEncr('0')
          );
          sessionStorage.setItem('Mnuoisns6wqgswj2$#', '0');

          let path = window.location.pathname.toLowerCase();
          //;
          if (
            path != '/login-corp' &&
            path != '/login-corp/investor' &&
            !path.includes('login') &&
            path != '/index' &&
            path != '/ipo' &&
            path != '/ipo/' &&
            path != '/ipo/index' &&
            path != '/'
          ) {
            $('.modal').modal('hide');

            this.SessionExpired();
            //;
            const LoginSource = sessionStorage.getItem('6+J3RebINEPBJVbAJw');
            $('#SessionModal').modal({
              backdrop: 'static',
              keyboard: false
            });
          }
          history.pushState(null, null, window.location.href);
          history.back();
          window.onpopstate = () => history.forward();
          $('select').select2('close');
        }
      }
    });
    //this.getCompanyDetails();
  }

  ngAfterViewInit() { // by pradnesh 28/08/2025
    // ===== Scroll to Top ====
    $(window).scroll(function () {
      if ($(this).scrollTop() >= 200) {
        // If page is scrolled more than 50px
        $('#return-to-top').fadeIn(200); // Fade in the arrow
      } else {
        $('#return-to-top').fadeOut(200); // Else fade out the arrow
      }
    });
    $(document).ready(function () {
      $('#return-to-top').click(function () {
        // When arrow is clicked
        $('body,html').animate(
          {
            scrollTop: 0 // Scroll to top of body
          },
          500
        );
      });
      $('.numonly').on('input', function () {
        var regexp = /[^\d\.\-]/g;
        if ($(this).val().match(regexp)) {
          $(this).val($(this).val().replace(regexp, ''));
        }
      });

      $('.alphaonly').on('input', function () {
        var regexp = /[^a-zA-Z ]/g;
        if ($(this).val().match(regexp)) {
          $(this).val($(this).val().replace(regexp, ''));
        }
      });
    });
  }
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.SetViewPort(event.target.innerWidth);
  }
  ngOnInit() {
    //environment.IsSubscribed = true; added this for testing once it is rectify then we change the publish condition.  for optimoney plus and optimoney
    window.addEventListener('beforeunload', () => {
      indexedDB.deleteDatabase(environment.DbName);
    });

    this.ShowHideheader();
    //this.Loader.show();
    $('.modal').modal('hide');

    //Press and hold the option URL can be seen 551
    this.unlisten = this.renderer.listen('document', 'touchstart', (event: TouchEvent) => {
      const target = event.target as HTMLElement;

      if (target.tagName === 'A' && target.getAttribute('href').startsWith('#') ) {
        event.preventDefault();  // Prevent iOS long press popup

        const id = target.getAttribute('href')!.substring(1);
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth' });
        }
      }
    });

    if (environment.CompayName == 'IFA') {
      ////;
      sessionStorage.removeItem('lkighty445dh==');
      var Domain_Name = window.location.host;
      //'Domain_Name="www.optimoney.in";'
      this.href = this.router.url;
      const json = {
        Domain_Name
      };
      // if (!environment.IsOptimoney ||(environment.IsOptimoney && environment.IsOptimoneyWealth))
      // {
      //;
      let str = JSON.stringify(json);
      this.LoginService.PostDomain(str).subscribe((res: any) => {
        //;

        this.appVariable.IsMFDData = 'true';

        var IFA_data = res.ArrayOfResponse[0];
        sessionStorage.setItem('lkighty445dh==IsSignUp', IFA_data.IsSignUp); //added by adarsh 03102025
        this.checkIsSignup(); //added by adarsh 03102025

        this.titleService.setTitle(IFA_data.Domain_Name);
        //added by adarsh 21052024
        sessionStorage.setItem('ihjt45h45=CompanyName', IFA_data.Domain_Name);
        sessionStorage.setItem('ihjt45h45=Domain_Url', IFA_data.Domain_Name2);
        if (!isNullOrUndefined(res.ArrayOfResponse[0].CompanyImage)) {
          //var baseStr64 = res.ArrayOfResponse[0].CompanyImage;
          this.CompanyLogo = res.ArrayOfResponse[0].CompanyImage;
          sessionStorage.setItem('lkighty445dh==', this.CompanyLogo);
          this.logoService.setLogo(this.CompanyLogo)
        }
        var lllg = sessionStorage.getItem('lkighty445dh==');

        // sessionStorage.setItem('ihjt45h45=a', IFA_data.IFA_AboutUs);
        // sessionStorage.setItem('ihjt45h45=b', IFA_data.equityMarketOutlook);
        // sessionStorage.setItem('ihjt45h45=c', IFA_data.Deptmarketoutlook);
        // sessionStorage.setItem('ihjt45h45=d', IFA_data.Deptmarketoutlook1);
        // sessionStorage.setItem('ihjt45h45=e', IFA_data.Deptmarketoutlook2);
        // sessionStorage.setItem('ihjt45h45=f', IFA_data.Whatclientsayspara);
        // sessionStorage.setItem('ihjt45h45=g', IFA_data.Whatclientsayspara1);
        // sessionStorage.setItem('ihjt45h45=h', IFA_data.Whatclientsayspara2);
        // sessionStorage.setItem('ihjt45h45=i', IFA_data.IFA_ContactUs);
        sessionStorage.setItem('ihjt45h45=jmail', IFA_data.IFA_MialIDs);
        // sessionStorage.setItem('ihjt45h45=k', IFA_data.IFA_CompanyMAilID);
        // sessionStorage.setItem('ihjt45h45=l', IFA_data.IFA_FooterContactlink);
        // sessionStorage.setItem('ihjt45h45=m', IFA_data.IFA__FootercontactNo);
        sessionStorage.setItem('ihjt45h45=n', IFA_data.IFA_FooterAddress);
        // sessionStorage.setItem('ihjt45h45=o', IFA_data.IFA_FooterAddressLink);
        sessionStorage.setItem('ihjt45h45=p', IFA_data.SubBrokerId);
        sessionStorage.setItem('ihjt45h45=q', IFA_data.ARNNO);
        sessionStorage.setItem('lkighty445dh==6', IFA_data.BannerImage);
        sessionStorage.setItem('lkighty445dh==7', IFA_data.AboutUsImage);
        sessionStorage.setItem('lkighty445dh==QR', IFA_data.UploadedQR);
        sessionStorage.setItem('lkighty445dh==WhatsAppQR', IFA_data.WhatsAppQR);
        sessionStorage.setItem(
          'lkighty445dh==WhatsAppLink',
          IFA_data.WhatsAppLink
        );
        sessionStorage.setItem(
          'lkighty445dh==FacebookLink',
          IFA_data.FacebookLink
        );
        sessionStorage.setItem(
          'lkighty445dh==LinkedInLink',
          IFA_data.LinkedInLink
        );
        sessionStorage.setItem(
          'lkighty445dh==TwitterLink',
          IFA_data.TwitterLink
        );
        sessionStorage.setItem(
          'lkighty445dh==InstagramLink',
          IFA_data.InstagramLink
        );
        sessionStorage.setItem('lkighty445dh==AppName', IFA_data.AppName);
        sessionStorage.setItem('lkighty445dh==RegNo', IFA_data.RegNo);
        sessionStorage.setItem('lkighty445dh==FromDate', IFA_data.FromDate);
        sessionStorage.setItem('lkighty445dh==ToDate', IFA_data.ToDate);
        sessionStorage.setItem(
          'lkighty445dh==Disclaimer',
          IFA_data.SiteDisclaimer
        );

        sessionStorage.setItem(
          'lkighty445dh==UserGuideLink',
          IFA_data.UserGuideLink
        ); //added by adarsh 03102025
        sessionStorage.setItem(
          'lkighty445dh==ReleaseNoteLink',
          IFA_data.ReleaseNoteLink
        ); //added by adarsh 03102025
        sessionStorage.setItem(
          'lkighty445dh==ClientOnboardUCCLink',
          IFA_data.ClientOnboardUCCLink
        ); //added by adarsh 03102025

        this.Googleplaylink = this.sanitizer.bypassSecurityTrustResourceUrl(
          IFA_data.GoogleplayLink
        ); //sessionStorage.getItem('ihjt45h45=t'));
        this.UploadedQR = 'data:image/jpg;base64,' + IFA_data.UploadedQR;
        this.WhatsAppQR = this.sanitizer.bypassSecurityTrustResourceUrl(
          'data:image/jpg;base64,' + IFA_data.WhatsAppQR
        );
        this.WhatsAppLink = this.sanitizer.bypassSecurityTrustResourceUrl(
          IFA_data.WhatsAppLink
        );

        // sessionStorage.setItem('ihjt45h45=r', IFA_data.InvestorName1);
        // sessionStorage.setItem('ihjt45h45=r1', IFA_data.InvestorName2);
        // sessionStorage.setItem('ihjt45h45=r2', IFA_data.InvestorName3);
        // sessionStorage.setItem('ihjt45h45=r3', IFA_data.InvestorName4);
        // sessionStorage.setItem('ihjt45h45=r4', IFA_data.InvestorName5);
        // sessionStorage.setItem('ihjt45h45=s', IFA_data.Investor1Discription);
        // sessionStorage.setItem('ihjt45h45=s1', IFA_data.Investor2Discription);
        // sessionStorage.setItem('ihjt45h45=s2', IFA_data.Investor3Discription);
        // sessionStorage.setItem('ihjt45h45=s3', IFA_data.Investor4Discription);
        // sessionStorage.setItem('ihjt45h45=s4', IFA_data.Investor5Discription);
        sessionStorage.setItem('ihjt45h45=t', IFA_data.GoogleplayLink);
        sessionStorage.setItem('ihjt45h45=app', IFA_data.AppleAppStoreLink);
        // sessionStorage.setItem('ihjt45h45=u', IFA_data.AppDownloadDiscription);
        // sessionStorage.setItem('ihjt45h45=v', IFA_data.Whatclientsayspara3);
        // sessionStorage.setItem('ihjt45h45=v1', IFA_data.Whatclientsayspara4);
        sessionStorage.setItem('ihjt45h45=sb', IFA_data.S_Brokerid);
        //this.CompanyLogo.setAttribute('src', "data:image/jpg;base64," + baseStr64);

        // sessionStorage.setItem('lkighty445dh==1', IFA_data.InvestorImage1);
        // sessionStorage.setItem('lkighty445dh==2', IFA_data.InvestorImage2);
        // sessionStorage.setItem('lkighty445dh==3', IFA_data.InvestorImage3);
        // sessionStorage.setItem('lkighty445dh==4', IFA_data.InvestorImage4);
        // sessionStorage.setItem('lkighty445dh==5', IFA_data.InvestorImage5);
        sessionStorage.setItem('lkighty445dh==8', this.DOE);
        sessionStorage.setItem('lkighty445dh==9', this.FIFO);
        document.documentElement.style.setProperty(
          '--primary-color-IFA',
          IFA_data.PrimaryColor
        );
        document.documentElement.style.setProperty(
          '--secondary-color-IFA',
          IFA_data.SecondaryColor
        );
        document.documentElement.style.setProperty(
          '--primary-color',
          IFA_data.PrimaryColor
        );
        document.documentElement.style.setProperty(
          '--secondary-color',
          IFA_data.SecondaryColor
        );
        this.IsLoaded = true;
        //this.Loader.show();
      });
      // }
    }
    ////;
    this.getCompanyDetails();
    switch (this.Companyname) {
      case 'IFA':
        this.PrimaryColor = environment.IsOptimoney ? '#3475c1' : '#00b387';
        this.SecondaryColor = environment.IsOptimoney ? '#34a853' : '#5367ff';
        this.ThirdColor = '#4285f4';
        this.BodyColor = '#162f3f';
        this.BodyBgColor = '#f1f3f4';
        this.BodyFooterBgColor = '#fff';
        this.Table_Header_Bg = '#f3f7fc';
        this.Table_Head_Text = '#162f3f';
        this.fontFamily = 'Inter';
        this.ClientDataService.SetWelcomeText('');
        if (environment.IsOptimoney == true) {
          this.titleService.setTitle('');
        }
        this.favIcon.href = '';
        // this.favIcon.href = './assets/images/favicon_IFA.ico';
        this.loader = '../../../assets/images/IFA/LoaderIFA.gif';
        this.loaderWidth = '100px';
        this.loaderHeight = '100px';
        sessionStorage.setItem('logo', '../../assets/images/OptimumLogo.svg');
        sessionStorage.setItem(
          'Abodhj#@jdkd/%^82ncdbcnggshd!@#$',
          this.EncrdecrService.setEncr('0')
        );
        sessionStorage.setItem('Mnuoisns6wqgswj2$#', '0');
        break;
    }
    this.ClientDataService.SetCompanyName(this.Companyname);
    document.documentElement.style.setProperty(
      '--primary-color',
      this.PrimaryColor
    );
    document.documentElement.style.setProperty(
      '--secondary-color',
      this.SecondaryColor
    );
    document.documentElement.style.setProperty(
      '--third-color',
      this.ThirdColor
    );
    document.documentElement.style.setProperty('--body-color', this.BodyColor);
    document.documentElement.style.setProperty(
      '--body-bg-color',
      this.BodyBgColor
    );
    document.documentElement.style.setProperty(
      '--body-footer-bg-color',
      this.BodyFooterBgColor
    );
    document.documentElement.style.setProperty(
      '--table-header-bg-color',
      this.Table_Header_Bg
    );
    document.documentElement.style.setProperty(
      '--table-header-text-color',
      this.Table_Head_Text
    );
    document.documentElement.style.setProperty(
      '--font-family-regular',
      `${this.fontFamily}Regular`
    );
    document.documentElement.style.setProperty(
      '--font-family-medium',
      `${this.fontFamily}Medium`
    );
    document.documentElement.style.setProperty(
      '--font-family-bold',
      `${this.fontFamily}Bold`
    );
  }

  OpenModalForAppQR() {
    this.CallAppQRModal();
  }
  CallAppQRModal() {
    $('#AppQRModal').modal({ backdrop: 'static', keyboard: false });
  }
  SetViewPort(w) {
    if (w <= 767) {
      this.IsMobile = true;
    } else {
      this.IsMobile = false;
    }
  }

  RelodePage() {
    location.reload();
  }
  getCompanyDetails() {
    //;
    this.ClientDataService.getCompanyDetails(environment.CompanyId).subscribe(
      (data: any) => {
        //;
        //
        if (data != null && data.ArrayOfResponse.length != 0) {
          //let dtsa = this.EncrdecrService.getDecr(data.ArrayOfResponse[0].Dummy2);
          //this.Loader.hide();
          let rk = data.ArrayOfResponse[0];

          var str = this.EncrdecrService.getDecr(rk.Dummy1);
          //;
          sessionStorage.setItem(
            'E#$%#XCha7%*=',
            this.EncrdecrService.getDecr(rk.Dummy2)
          );
          sessionStorage.setItem(
            'Vbhs@#%LMKIo=',
            this.EncrdecrService.getDecr(rk.Dummy1)
          );
          sessionStorage.setItem(
            'DufjGDH3843JE',
            this.EncrdecrService.getDecr(rk.Dummy4)
          );
          sessionStorage.setItem(
            'PfdkSJDNWks2323Ms',
            this.EncrdecrService.getDecr(rk.Dummy3)
          );
          sessionStorage.setItem(
            'Arh34SDBJSSiF',
            this.EncrdecrService.getDecr(rk.Dummy5)
          );
          sessionStorage.setItem(
            'Fhd63asja$%Wsdjs9304#@dfvdjfjd',
            this.EncrdecrService.getDecr(rk.Dummy6)
          );
          sessionStorage.setItem(
            '%^&s8g9b!@fla%g',
            this.EncrdecrService.getDecr(rk.Dummy7)
          );
          sessionStorage.setItem(
            'JikLG6K4LOdfv',
            this.EncrdecrService.getDecr(rk.Dummy11)
          );
          if (!isNullOrUndefined(rk.Dummy12)) {
            sessionStorage.setItem(
              'Hjgir56hutHLB',
              this.EncrdecrService.getDecr(rk.Dummy12)
            );
          }

          try {
            if (!isNullOrUndefined(this.EncrdecrService.getDecr(rk.Dummy8))) {
              sessionStorage.setItem(
                'trtygy$gtdr&dft=',
                this.EncrdecrService.getDecr(rk.Dummy8)
              );
            } else {
              sessionStorage.setItem('trtygy$gtdr&dft=', 'false');
            }
          } catch (e) {
            sessionStorage.setItem('trtygy$gtdr&dft=', 'false');
          }
          try {
            if (!isNullOrUndefined(this.EncrdecrService.getDecr(rk.Dummy9))) {
              sessionStorage.setItem(
                'hgjhfjg&jbfj%dfgs=',
                this.EncrdecrService.getDecr(rk.Dummy9)
              );
            } else {
              sessionStorage.setItem('hgjhfjg&jbfj%dfgs=', 'false');
            }
          } catch (e) {
            sessionStorage.setItem('hgjhfjg&jbfj%dfgs=', 'false');
          }
          try {
            if (!isNullOrUndefined(this.EncrdecrService.getDecr(rk.Dummy10))) {
              sessionStorage.setItem(
                'dsa&hdhbc%ube=',
                this.EncrdecrService.getDecr(rk.Dummy10)
              );
            } else {
              sessionStorage.setItem('dsa&hdhbc%ube=', 'false');
            }
          } catch (e) {
            sessionStorage.setItem('dsa&hdhbc%ube=', 'false');
          }
        }
      }
    );
  }

  SessionExpired() {
    //;
    let LoginToken = sessionStorage.getItem('`huR,8@RK9^??b4 -.hfs!!uR,XX');
    const CompanyName: string = environment.CompayName; //added by adarsh
    var G_UserType = parseInt(
      this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
    ); //Session_UserType //added by adarsh
    // const LoginSource = sessionStorage.getItem('6+J3RebINEPBJVbAJw');
    var SB_Session = sessionStorage.getItem('ihjt45h45=p'); //added by adarsh
    var CompanyLogo = sessionStorage.getItem('lkighty445dh=='); //added by adarsh
    this.LoginService.Logout(LoginToken).subscribe((res: any) => {
      const sessionvalue = sessionStorage.getItem('nvjsd212djskd$#21ksdj');

      this.Logout.LogoutUser();
      sessionStorage.clear();
      localStorage.clear();
      switch (this.Companyname) {
        case 'IFA':
          if (G_UserType && CompanyName == 'IFA') {
            //;
            sessionStorage.setItem('ihjt45h45=p', SB_Session); //added by adarsh
            sessionStorage.setItem('lkighty445dh==', CompanyLogo); //added by adarsh
          } else {
            //;
            sessionStorage.setItem('lkighty445dh==', CompanyLogo); //added by adarsh
          }
          break;
      }
    });
  }
  RedirectTODashBoard() {
    var G_UserType = parseInt(
      this.EncrdecrService.getDecr(sessionStorage.getItem('L2D3506kIHSk3E0'))
    ); //Session_UserType
    if (G_UserType == 3) {
      this.router.navigateByUrl('client-dashboard');
    } else if (G_UserType == 2) {
      //added by adarsh 22082023
      this.router.navigateByUrl('dashboard');
    } else {
      this.router.navigateByUrl('employee-dashboard');
      this.router.navigateByUrl('/employee');
    }
  }
  checkactivelink() {
    //;
    let path = window.location.pathname;
    if (!path.includes('value-add-service')) {
      $('#Id_ValueAdds .nav-link').removeClass('active');
    } else {
      $('#Id_ValueAdds .nav-link').addClass('active');
    }
  }
  OnDelete() {
    $('#SureDelete').modal({ backdrop: 'static', keyboard: false });
    this.closeNav();
  }

  closeNav() {
    document.getElementById('mySidenav').style.width = '0';
  }
  checkIsSignup() {
    setInterval(() => {
      if (sessionStorage.getItem('lkighty445dh==IsSignUp') == 'Y') {
        environment.IsSubscribed = true;
      } else {
        environment.IsSubscribed = false;
      }
    }, 500);
  }
  ShowHideheader() {
    setInterval(() => {
      //     if(isNullOrUndefined(sessionStorage.getItem('ShowHeader')))
      //  {
      //   this.IsShowHide = false
      //  }
      //  else{
      //   this.IsShowHide = true
      //  }
      // //this. checkactivelink();
      let IsLoggedIn = this.authservice.isAuthenticated(); // don't forget this!
      let path = window.location.pathname;
      // if (path != '/login' && path != '/login/investor' && !path.includes("login") && path != '/forgot-password' && path != '/generate-password' && path != '/client-preOnboading' && path != '/' ) {
      if (
        path == '/dashboard' ||
        path == '/client-dashboard' ||
        path == '/clients' ||
        path == '/client-profile' ||
        path.includes('/transaction') ||
        path == '/explore-funds' ||
        path.includes('/reports') ||
        path == '/calculators' ||
        path.includes('/value-add-service') ||
        path == '/merge-client' ||
        path == '/distributor-profile' ||
        path == '/factsheet' ||
        path.includes('/business')
      ) {
        if (IsLoggedIn && !this.IsShowHide) {
          this.IsShowHide = true;
          // $("#IsShowHideheader").show();
        } else if (!IsLoggedIn) {
          this.IsShowHide = false;
          // $("#IsShowHideheader").hide();
        }
      } else {
        this.IsShowHide = false;
      }

      ////////
      if (
        path == '/mfmain/home' ||
        path == '/mf/About' ||
        path == '/mf/MarketViews' ||
        path == '/mf/Wealth_Calculators' ||
        path == '/mf/Reviews' ||
        path == '/mf/Contact' ||
        path == '/Disclaimer'
      ) {
        sessionStorage.removeItem('pageNotFound');

        if ((!IsLoggedIn && !this.IsShowHideIFAHeader) || !IsLoggedIn) {
          this.IsShowHideIFAHeader = true;
          this.IsShowHideQR = true;
          // $("#IsShowHideheader").show();
        }
        //  else if(!IsLoggedIn){
        //    this.IsShowHideIFAHeader = true;
        //   // $("#IsShowHideheader").hide();

        //  }
      } else {
        this.IsShowHideIFAHeader = false;
        this.IsShowHideQR = false;
      }
      if (path == '/mfmain/home') this.IsShowHideIFAHeader = true; //GDOM-354
    }, 500);
  }

  ngOnDestroy() {
    this.unlisten();
  }

}

